import {LobbyImage} from '@colonist/types'
import {createButtonIn, createDivIn, createImgIn, setElementInnerHTML} from '../../../../../../../shared/scripts/ui_utils/DomUtils'
import {UIMFullscreenPageView} from '../../../../../ui_page/UIMFullscreenPageView'
import {UIMMatchmakingController} from './UIMMatchmakingController'
import {ClientUserState} from '../../../../../../../shared/scripts/ClientUserState'
import {TranslationObject} from '@colonist/i18n'
import IconLock from '@static/images/icon_lock.svg'

export class UIMMatchmakingSelectionView extends UIMFullscreenPageView {
    private readonly selectionTitle: TranslationObject
    private readonly imageSrc: LobbyImage
    private buttonContainer: HTMLDivElement | undefined
    readonly totalCompletedGameCount: number
    readonly matchmakingController: UIMMatchmakingController

    constructor(matchmakingController: UIMMatchmakingController, title: TranslationObject, imageSrc: LobbyImage) {
        super({key: 'strings:colonistCommon.utils.emptyString'}, 'matchmaking-selection', () => undefined, 'matchmaking-selection-body')
        this.build()
        this.selectionTitle = title
        this.imageSrc = imageSrc
        this.matchmakingController = matchmakingController
        this.totalCompletedGameCount = ClientUserState.userState?.totalCompletedGameCount ?? 0
    }

    addTitle() {
        setElementInnerHTML(this.header.title, this.selectionTitle)
        this.header.backButton.onclick = () => this.removeFromDOM()
    }

    addImage() {
        createImgIn(this.body, this.imageSrc, 'm-gamemode-img')
    }

    renderSelectionScreen() {
        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})
    }

    addButton(title: TranslationObject, subTitle: TranslationObject, shouldShowLockIcon: boolean = false) {
        if(this.buttonContainer == undefined) this.buttonContainer = createDivIn(this.body, 'm-matchmaking-buttons-container')
        const buttonElement = createButtonIn(this.buttonContainer, 'm-matchmaking-button', {key: 'strings:colonistCommon.utils.emptyString'})

        const titleContainer = document.createElement('div')
        titleContainer.classList.add('m-matchmaking-title-container')

        const titleElement = document.createElement('h2')
        setElementInnerHTML(titleElement, title)
        titleElement.classList.add('m-outlined')
        titleContainer.appendChild(titleElement)

        if(shouldShowLockIcon) {
            const image = document.createElement('img')
            image.src = IconLock
            titleContainer.appendChild(image)
        }

        buttonElement.appendChild(titleContainer)

        const subtextElement = document.createElement('p')
        setElementInnerHTML(subtextElement, subTitle)
        buttonElement.appendChild(subtextElement)
        return buttonElement
    }

    buildView(): void {
        void this
    }
}
